import React from "react";
import PropTypes from "prop-types";
import "./Contact.css";
import {delimit} from "../StringUtils";

function Contact(props) {
	if (props.appSettings == null) {
		return <h1>Loading...</h1>;
	}
	let settings=props.appSettings;
	let cityStateZip = delimit(settings["publisher.city"], delimit(settings["publisher.state"], settings["publisher.zip"], " "), ", ");
	let phone = settings["publisher.phone"] ? "Phone: "+settings["publisher.phone"] : null;
	let fax = settings["publisher.fax"] ? "Fax: "+settings["publisher.fax"] : null;
	return (
		<div className="contactInfo">
			<h2>How To Contact Us</h2>
			<div className="contactAddress">
				<p><strong>{settings["publisher.name"]}</strong></p>
				<p>{settings["publisher.address1"]}</p>
				<p>{cityStateZip}</p>
			</div>
			<p>{phone}</p>
			<p>{fax}</p>
		</div>
	);
}

Contact.propTypes = {
	appSettings: PropTypes.object
};

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js